var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncomingCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8 12.4999C10.4111 12.4999 9.03889 12.1973 7.68333 11.5919C6.32778 10.9866 5.09444 10.1282 3.98333 9.01661C2.87222 7.90505 2.014 6.67172 1.40867 5.31661C0.803333 3.9615 0.500444 2.58928 0.5 1.19994C0.5 0.999943 0.566667 0.833276 0.7 0.699943C0.833333 0.56661 1 0.499943 1.2 0.499943H3.9C4.05556 0.499943 4.19444 0.552832 4.31667 0.65861C4.43889 0.764387 4.51111 0.889276 4.53333 1.03328L4.96667 3.36661C4.98889 3.54439 4.98333 3.69439 4.95 3.81661C4.91667 3.93883 4.85556 4.04439 4.76667 4.13328L3.15 5.76661C3.37222 6.17772 3.636 6.57483 3.94133 6.95794C4.24667 7.34105 4.58289 7.71061 4.95 8.06661C5.29444 8.41105 5.65556 8.73061 6.03333 9.02528C6.41111 9.31994 6.81111 9.58928 7.23333 9.83328L8.8 8.26661C8.9 8.16661 9.03067 8.09172 9.192 8.04194C9.35333 7.99217 9.51156 7.97817 9.66667 7.99994L11.9667 8.46661C12.1222 8.51105 12.25 8.59172 12.35 8.70861C12.45 8.8255 12.5 8.95594 12.5 9.09994V11.7999C12.5 11.9999 12.4333 12.1666 12.3 12.2999C12.1667 12.4333 12 12.4999 11.8 12.4999ZM7.16667 5.83328V1.83328H8.5V3.56661L11.8333 0.233276L12.7667 1.16661L9.43333 4.49994H11.1667V5.83328H7.16667Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomingCall);
export default __webpack_public_path__ + "static/media/incoming-call.a84e7dfe766357b751d8576f3fd04dd9.svg";
export { ForwardRef as ReactComponent };